// import Adminnavbar from "./Adminnavbar";

// export default function Admindashbord() {
//   return (
//     <div>
//       <Adminnavbar />
//       <div className="page-wrapper">
//         <div className="content">
//           <div className="row">
//             <div className="col-lg-3 col-sm-6 col-12 d-flex widget-path widget-service">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="home-user">
//                     <div className="home-userhead">
//                       <div className="home-usercount">
//                         <span>
//                           <img src="assets/img/icons/user.svg" alt="img" />
//                         </span>
//                         <h6>User</h6>
//                       </div>
//                       <div className="home-useraction">
//                         <a
//                           className="delete-table bg-white"
//                           href="javascript:void(0);"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="true"
//                         >
//                           <i
//                             className="fa fa-ellipsis-v"
//                             aria-hidden="true"
//                           ></i>
//                         </a>
//                         <ul
//                           className="dropdown-menu"
//                           data-popper-placement="bottom-end"
//                         >
//                           <li>
//                             <a href="user-list.html" className="dropdown-item">
//                               {" "}
//                               View
//                             </a>
//                           </li>
//                           <li>
//                             <a href="edit-user.html" className="dropdown-item">
//                               {" "}
//                               Edit
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="home-usercontent">
//                       <div className="home-usercontents">
//                         <div className="home-usercontentcount">
//                           <img
//                             src="assets/img/icons/arrow-up.svg"
//                             alt="img"
//                             className="me-2"
//                           />
//                           <span className="counters" data-count="30">
//                             30
//                           </span>
//                         </div>
//                         <h5> Current Month</h5>
//                       </div>
//                       <div className="homegraph">
//                         <img src="assets/img/graph/graph1.png" alt="img" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-sm-6 col-12 d-flex widget-path widget-service">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="home-user home-provider">
//                     <div className="home-userhead">
//                       <div className="home-usercount">
//                         <span>
//                           <img
//                             src="assets/img/icons/user-circle.svg"
//                             alt="img"
//                           />
//                         </span>
//                         <h6>Providers</h6>
//                       </div>
//                       <div className="home-useraction">
//                         <a
//                           className="delete-table bg-white"
//                           href="javascript:void(0);"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="true"
//                         >
//                           <i
//                             className="fa fa-ellipsis-v"
//                             aria-hidden="true"
//                           ></i>
//                         </a>
//                         <ul
//                           className="dropdown-menu"
//                           data-popper-placement="bottom-end"
//                         >
//                           <li>
//                             <a
//                               href="user-providers.html"
//                               className="dropdown-item"
//                             >
//                               {" "}
//                               View
//                             </a>
//                           </li>
//                           <li>
//                             <a
//                               href="edit-provider.html"
//                               className="dropdown-item"
//                             >
//                               {" "}
//                               Edit
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="home-usercontent">
//                       <div className="home-usercontents">
//                         <div className="home-usercontentcount">
//                           <img
//                             src="assets/img/icons/arrow-up.svg"
//                             alt="img"
//                             className="me-2"
//                           />
//                           <span className="counters" data-count="25">
//                             25
//                           </span>
//                         </div>
//                         <h5> Current Month</h5>
//                       </div>
//                       <div className="homegraph">
//                         <img src="assets/img/graph/graph2.png" alt="img" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-sm-6 col-12 d-flex widget-path widget-service">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="home-user home-service">
//                     <div className="home-userhead">
//                       <div className="home-usercount">
//                         <span>
//                           <img src="assets/img/icons/service.svg" alt="img" />
//                         </span>
//                         <h6>Service</h6>
//                       </div>
//                       <div className="home-useraction">
//                         <a
//                           className="delete-table bg-white"
//                           href="javascript:void(0);"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="true"
//                         >
//                           <i
//                             className="fa fa-ellipsis-v"
//                             aria-hidden="true"
//                           ></i>
//                         </a>
//                         <ul
//                           className="dropdown-menu"
//                           data-popper-placement="bottom-end"
//                         >
//                           <li>
//                             <a href="listings.html" className="dropdown-item">
//                               {" "}
//                               View
//                             </a>
//                           </li>
//                           <li>
//                             <a
//                               href="edit-service.html"
//                               className="dropdown-item"
//                             >
//                               {" "}
//                               Edit
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="home-usercontent">
//                       <div className="home-usercontents">
//                         <div className="home-usercontentcount">
//                           <img
//                             src="assets/img/icons/arrow-up.svg"
//                             alt="img"
//                             className="me-2"
//                           />
//                           <span className="counters" data-count="18">
//                             18
//                           </span>
//                         </div>
//                         <h5> Current Month</h5>
//                       </div>
//                       <div className="homegraph">
//                         <img src="assets/img/graph/graph3.png" alt="img" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-sm-6 col-12 d-flex widget-path widget-service">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="home-user home-subscription">
//                     <div className="home-userhead">
//                       <div className="home-usercount">
//                         <span>
//                           <img src="assets/img/icons/money.svg" alt="img" />
//                         </span>
//                         <h6>Subscription</h6>
//                       </div>
//                       <div className="home-useraction">
//                         <a
//                           className="delete-table bg-white"
//                           href="javascript:void(0);"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="true"
//                         >
//                           <i
//                             className="fa fa-ellipsis-v"
//                             aria-hidden="true"
//                           ></i>
//                         </a>
//                         <ul
//                           className="dropdown-menu"
//                           data-popper-placement="bottom-end"
//                         >
//                           <li>
//                             <a href="membership.html" className="dropdown-item">
//                               {" "}
//                               View
//                             </a>
//                           </li>
//                           <li>
//                             <a
//                               href="javascript:void(0);"
//                               className="dropdown-item"
//                             >
//                               {" "}
//                               Edit
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="home-usercontent">
//                       <div className="home-usercontents">
//                         <div className="home-usercontentcount">
//                           <img
//                             src="assets/img/icons/arrow-up.svg"
//                             alt="img"
//                             className="me-2"
//                           />
//                           <span className="counters" data-count="650">
//                             650
//                           </span>
//                         </div>
//                         <h5> Current Month</h5>
//                       </div>
//                       <div className="homegraph">
//                         <img src="assets/img/graph/graph4.png" alt="img" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-12 widget-path">
//               <div className="card mb-0">
//                 <div className="card-body">
//                   <div className="home-user">
//                     <div className="home-head-user home-graph-header">
//                       <h2>Recent Booking</h2>
//                       <a href="booking.html" className="btn btn-viewall">
//                         View All<i className="fa-solid fa-arrow-right ms-2"></i>
//                       </a>
//                     </div>
//                     <div className="table-responsive datatable-nofooter">
//                       <div
//                         id="DataTables_Table_2_wrapper"
//                         className="dataTables_wrapper dt-bootstrap4 no-footer"
//                       >
//                         <table
//                           className="table datatable dataTable no-footer"
//                           id="DataTables_Table_2"
//                           role="grid"
//                           aria-describedby="DataTables_Table_2_info"
//                         >
//                           <thead>
//                             <tr role="row">
//                               <th>#</th>
//                               <th>Date</th>
//                               <th>Booking Time</th>
//                               <th>Provider</th>
//                               <th>User</th>
//                               <th>Service</th>
//                               <th>Amount</th>
//                               <th>Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             <tr className="odd">
//                               <td className="sorting_1">1</td>
//                               <td>28 Sep 2022</td>
//                               <td>10:00:00 - 11:00:00</td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-01.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>John Smith</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-03.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Sharon</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="view-service.html"
//                                   className="table-imgname"
//                                 >
//                                   <img
//                                     src="assets/img/services/service-03.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Computer Repair</span>
//                                 </a>
//                               </td>
//                               <td>$80</td>
//                               <td>
//                                 <h6 className="badge-pending">Pending</h6>
//                               </td>
//                             </tr>
//                             <tr className="even">
//                               <td className="sorting_1">2</td>
//                               <td>10 Sep 2022</td>
//                               <td>18:00:00 - 19:00:00 </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-04.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Johnny</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-05.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Pricilla</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="view-service.html"
//                                   className="table-imgname"
//                                 >
//                                   <img
//                                     src="assets/img/services/service-02.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Car Repair Services</span>
//                                 </a>
//                               </td>
//                               <td>$50</td>
//                               <td>
//                                 <h6 className="badge-active">Completed</h6>
//                               </td>
//                             </tr>
//                             <tr className="odd">
//                               <td className="sorting_1">3</td>
//                               <td>25 Sep 2022</td>
//                               <td>12:00:00 - 13:00:00</td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-06.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Robert</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-02.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Amanda</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="view-service.html"
//                                   className="table-imgname"
//                                 >
//                                   <img
//                                     src="assets/img/services/service-04.png"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Steam Car Wash</span>
//                                 </a>
//                               </td>
//                               <td>$50</td>
//                               <td>
//                                 <h6 className="badge-inactive">Inprogress</h6>
//                               </td>
//                             </tr>
//                             <tr className="even">
//                               <td className="sorting_1">4</td>
//                               <td>08 Sep 2022</td>
//                               <td>07 Oct 2022 11:22:51</td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-09.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Sharonda</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-01.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>James</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="view-service.html"
//                                   className="table-imgname"
//                                 >
//                                   <img
//                                     src="assets/img/services/service-09.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>House Cleaning </span>
//                                 </a>
//                               </td>
//                               <td>$50</td>
//                               <td>
//                                 <h6 className="badge-delete">cancelled</h6>
//                               </td>
//                             </tr>
//                             <tr className="odd">
//                               <td className="sorting_1">5</td>
//                               <td>28 Sep 2022</td>
//                               <td>10:00:00 - 11:00:00</td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-01.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>John Smith</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="javascript:void(0);"
//                                   className="table-profileimage"
//                                 >
//                                   <img
//                                     src="assets/img/customer/user-03.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Sharon</span>
//                                 </a>
//                               </td>
//                               <td>
//                                 <a
//                                   href="view-service.html"
//                                   className="table-imgname"
//                                 >
//                                   <img
//                                     src="assets/img/services/service-03.jpg"
//                                     className="me-2"
//                                     alt="img"
//                                   />
//                                   <span>Computer Repair</span>
//                                 </a>
//                               </td>
//                               <td>$80</td>
//                               <td>
//                                 <h6 className="badge-pending">Pending</h6>
//                               </td>
//                             </tr>
//                           </tbody>
//                         </table>
//                         <div
//                           className="dataTables_length"
//                           id="DataTables_Table_2_length"
//                         >
//                           <label>
//                             <select
//                               name="DataTables_Table_2_length"
//                               aria-controls="DataTables_Table_2"
//                               className="custom-select custom-select-sm form-control form-control-sm"
//                             >
//                               <option value="10">10</option>
//                               <option value="25">25</option>
//                               <option value="50">50</option>
//                               <option value="100">100</option>
//                             </select>
//                           </label>
//                         </div>
//                         <div
//                           className="dataTables_paginate paging_numbers"
//                           id="DataTables_Table_2_paginate"
//                         >
//                           <ul className="pagination">
//                             <li className="paginate_button page-item active">
//                               <a
//                                 href="#"
//                                 aria-controls="DataTables_Table_2"
//                                 data-dt-idx="0"
//                                 tabIndex="0"
//                                 className="page-link"
//                               >
//                                 1
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                         <div
//                           className="dataTables_info"
//                           id="DataTables_Table_2_info"
//                           role="status"
//                           aria-live="polite"
//                         >
//                           1 - 5 of 5 items
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { Link } from "react-router-dom";
import Adminnavbar from "./Adminnavbar";

export default function AdminDashboard() {
  return (
    <>
      <Adminnavbar />

      <div className="page-wrapper page-settings">
        <div className="content">
          {/* BREADCRUMB */}
          <nav
            aria-label="breadcrumb"
            style={{ "--bs-breadcrumb-divider": "none" }}
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>

          {/* PAGE TITLE */}
          <div className="content-page-header mb-4">
            <h5>Dashboard</h5>
          </div>

          {/* DASHBOARD CARDS */}
          <div className="row">
            {/* BLOGS */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="shortcut-card">
                <div className="shortcut-header">
                  <div className="shortcut-icon">
                    <i className="fa fa-blog"></i>
                  </div>
                  <h4>Blogs</h4>
                </div>

                <p>Manage blog posts and content</p>

                <Link to="/knowledge-center-list" className="shortcut-link">
                  View Blogs →
                </Link>
              </div>
            </div>

            {/* PPT & Tools Download */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="shortcut-card">
                <div className="shortcut-header">
                  <div className="shortcut-icon">
                    <i className="fa fa-upload"></i>
                  </div>
                  <h4>PPT & Tools Upload </h4>
                </div>

                <p>Upload and manage downloadable files</p>

                <Link to="/ppt-tool-list" className="shortcut-link">
                  View Uploads →
                </Link>
              </div>
            </div>

            {/* PDF DOWNLOAD */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="shortcut-card">
                <div className="shortcut-header">
                  <div className="shortcut-icon">
                    <i className="fa fa-file-pdf"></i>
                  </div>
                  <h4>PDF Downloads</h4>
                </div>

                <p>View user downloaded PDF reports</p>

                <Link to="/pdf-download-list" className="shortcut-link">
                  View Reports →
                </Link>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
}
